import type { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
    borderRadius: '0.5rem',
    border: `1px solid ${theme.colors.borderColor}`,
    backgroundColor: theme.colors.white,
    height: '100%',
    boxSizing: 'border-box',
});

export const serviceName: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.text,
    fontWeight: 600,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    marginBottom: '0.625rem',
});

export const metaRow: TRuleWithTheme = () => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.375rem 1.25rem',
});

export const metaItem: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
});

export const metaLabel: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.textSecondary,
    fontSize: '0.6875rem',
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
});

export const metaValue: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.text,
    fontSize: '0.8125rem',
    fontWeight: 500,
});

export const metaValueMuted: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.textSecondary,
    fontSize: '0.8125rem',
    fontStyle: 'italic',
});
